import { FullPageDotLoading } from '@xing-com/crate-jobs-components-full-page-dot-loading';
import { LoadingError } from '@xing-com/crate-jobs-domain-apply-components';
import type { InstantApplyJobDataXingletLOProps } from '@xing-com/crate-jobs-domain-apply-types';
import { JobsXingletWrapper } from '@xing-com/crate-jobs-xinglets';

export const InstantApplyLoggedOut =
  JobsXingletWrapper<InstantApplyJobDataXingletLOProps>(
    '@xing-com/crate-jobs-domain-instant-apply-logged-out',
    <FullPageDotLoading />,
    <LoadingError
      refetch={() => {
        window.location.reload();
      }}
    />
  );
